module.exports = __webpack_public_path__ + "img/dining-out.4073a519.png";